import { useState, useCallback } from 'react'

/**
 * Custom hook to manage action dialogs state
 * @returns {Object} - Dialog state and handlers
 */
export const useActionDialogs = () => {
	const [actionDialogs, setActionDialogs] = useState({
		subscription: { open: false },
		contactSupport: { open: false },
	})

	const handleActionDialogsOpen = useCallback((name, data = {}) => {
		setActionDialogs((prev) => ({
			...prev,
			[name]: { open: true },
			cellData: data,
		}))
	}, [])

	const handleActionDialogsClose = useCallback((name) => {
		setActionDialogs((prev) => ({
			...prev,
			[name]: { open: false },
			cellData: {},
		}))
	}, [])

	return {
		actionDialogs,
		handleActionDialogsOpen,
		handleActionDialogsClose,
	}
}

